import React from "react";
import { FormatMoney } from "../../../Helpers/FormatNumber";

export const TrDetalleEmbudoVentas = ({
  data, //esta data ya fiene filtrada por la linea
  sucursales,
  fases,
  obtenerTotalFila,
  verpor
}) => {

  const mostrarValor = (cantidad, monto) => {
    if (verpor === "unidades") return cantidad || 0;

    if (verpor === "montos") return FormatMoney(monto, 0) || 0;

    if (verpor === "unidadesmonto")
      return `${cantidad || 0} - $${FormatMoney(monto, 0) || 0}`;

    return cantidad || 0;
  };

  const arrayPorLinea = (fase) => {
    return sucursales.map((suc) => {
      const result = data.find(
        (x) =>
          x.fase?.trim().toLowerCase() === fase.trim().toLowerCase() &&
          x.columna?.trim().toLowerCase() === suc.trim().toLowerCase()
      );

      return {
        cantidad: result?.cantidad || 0,
        monto: result?.monto || 0
      };
    });
  };

  return fases.map((f) => {
    // total por fase de esta línea
    const valoresFila = arrayPorLinea(f);

    const totalCantidad = valoresFila.reduce((sum, x) => sum + (x.cantidad || 0), 0);
    const totalMonto = valoresFila.reduce((sum, x) => sum + (x.monto || 0), 0);

    const totalFila = mostrarValor(totalCantidad, totalMonto);

    return (
      <tr key={f} className="pebcd-tabla-rdetalle">
        <td>{f}</td>

        {arrayPorLinea(f).map((x, i) => (
          <td key={i} className="ta-center">
            {mostrarValor(x.cantidad, x.monto)}
          </td>
        ))}

        {/*Nueva columna: TOTAL POR FILA */}
        <td className="ta-center" style={{ fontWeight: "bold" }}>
          {totalFila}
        </td>
      </tr>
    );
  });
};